module.exports = __webpack_public_path__ + "img/icon-video.5933e8c.png";